<template>
  <div style="position: relative">
    <div class="make-call-button" v-if="!mobileDevice">
      <el-button-group
        style="width: 230px"
        v-if="!navCollapsed && userHasExtension"
      >
        <el-button
          :disabled="!softphoneEnabled"
          style="width: 195px; height: 44px"
          @click="toggleSoftphone(true)"
        >
          <v-svg sprite="call-2" v-if="softphoneEnabled" />
          <span class="make-call-text ml-10">
            {{ softphoneEnabled ? "Make a call" : "Softphone disabled" }}
          </span>
        </el-button>
        <el-dropdown
          trigger="click"
          class="make-call-dropdown"
          @command="onCommand"
        >
          <el-button class="ml-0">
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="startVideoCall">
              <v-svg sprite="video" class="voxo-blue"></v-svg>
              Start meeting
            </el-dropdown-item>
            <el-dropdown-item command="scheduleVideoCall">
              <v-svg sprite="calendar" class="voxo-blue"></v-svg>
              Schedule meeting
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-button-group>
    </div>

    <div class="my-calls-view">
      <div
        class="current-call-item"
        v-for="(item, index) in myParkedCalls"
        :key="index"
      >
        <parked-call
          :parkingSpace="item.parkingSpace"
          :parkingLot="item.parkingLot"
          :callerName="item.callerName"
          :callerNumber="item.callerNumber"
        />
      </div>
      <div
        class="current-call-item"
        v-for="item in myCurrentCalls"
        :key="item.channel"
      >
        <connected-call
          :channel="item.channel"
          :systemname="item.systemname"
          :cidnum="item.cidnum"
          :cidname="item.cidname"
          :direction="item.direction"
          :duration="item.duration"
          :disabled-buttons="item.disabledButtons"
          :call-item="item"
          :status="item.status"
          :softphone-call="item.softphoneCall"
          :sipHandle="item.sipHandle"
          :onHold="item.onHold"
          :atxferActive="item.atxferActive"
          :atxferCallerId="item.atxferCallerId"
          :conferencing="item.conferencing"
          :participants="item.participants"
          :confBridgeId="item.bridgeId"
          :dtmfNums="item.dtmfNums ? item.dtmfNums : []"
        />
      </div>
    </div>

    <el-menu
      ref="portalNav"
      v-if="!hudMode"
      :default-active.sync="activeLink"
      :mode="mode"
      @select="goto"
      :collapse="isCollapse"
      :unique-opened="true"
      class="main-navigation-menu"
      :class="{ 'nav-collapsed': isCollapse }"
    >
      <el-menu-item index="/dashboard" v-if="!queueAdmin || reportingAdmin">
        <v-svg class="voxo-blue" sprite="mockup" />
        <span slot="title">Dashboard</span>
      </el-menu-item>

      <el-submenu index="PhoneSystem" v-if="queueAdmin">
        <template slot="title">
          <v-svg class="voxo-aqua" sprite="telephone-3" />
          <span>Phone System</span>
        </template>
        <el-menu-item index="/call-queues">
          <v-svg class="voxo-red" sprite="queue" />
          <span slot="title">Call Queues</span>
        </el-menu-item>
      </el-submenu>

      <el-submenu index="PhoneSystem" v-if="!reportingAdmin && !queueAdmin">
        <template slot="title">
          <v-svg class="voxo-aqua" sprite="telephone-3" />
          <span>Phone System</span>
        </template>
        <el-menu-item index="/extensions">
          <v-svg class="voxo-green" sprite="telephone-2" />
          <span slot="title">Extensions</span>
        </el-menu-item>
        <el-menu-item index="/phone-numbers">
          <v-svg class="voxo-aqua" sprite="phone-number" />
          <span slot="title">Phone Numbers</span>
        </el-menu-item>
        <el-menu-item index="/time-of-days">
          <v-svg class="voxo-green" sprite="clock" />
          <span slot="title">Time of days</span>
        </el-menu-item>
        <el-menu-item index="/virtual-receptionist">
          <v-svg class="voxo-purple" sprite="receptionist" />
          <span slot="title">Virtual Receptionists</span>
        </el-menu-item>
        <el-menu-item index="/call-groups">
          <v-svg class="voxo-orange" sprite="group" />
          <span slot="title">Call Groups</span>
        </el-menu-item>
        <el-menu-item index="/call-queues">
          <v-svg class="voxo-red" sprite="queue" />
          <span slot="title">Call Queues</span>
        </el-menu-item>
        <el-menu-item index="/feature-codes">
          <v-svg class="voxo-blue" sprite="hash" />
          <span slot="title">Feature Codes</span>
        </el-menu-item>
        <el-menu-item index="/voicemails">
          <v-svg class="voxo-purple" sprite="voicemail-2" />
          <span slot="title">Voicemails</span>
        </el-menu-item>
        <!--        <el-menu-item index="/donotcalls">-->
        <!--          <v-svg class="voxo-red" sprite="call-block" />-->
        <!--          <span  slot="title">Do Not Call Lists</span>-->
        <!--        </el-menu-item>-->
        <el-menu-item index="/campaigns">
          <v-svg class="voxo-green" sprite="call-2" />
          <span slot="title">Campaigns</span>
        </el-menu-item>
        <el-menu-item index="/devices">
          <v-svg class="voxo-yellow" sprite="devices" />
          <span slot="title">Devices</span>
        </el-menu-item>
        <el-menu-item index="/faxes">
          <v-svg class="voxo-orange" sprite="fax-2" />
          <span slot="title">Faxes</span>
        </el-menu-item>
        <el-menu-item index="/paging-groups">
          <v-svg class="voxo-green" sprite="megaphone" />
          <span slot="title">Paging Groups</span>
        </el-menu-item>
        <el-menu-item index="/call-blocking">
          <v-svg class="voxo-dark-red" sprite="call-block" />
          <span slot="title">Call Blocking</span>
        </el-menu-item>
        <el-menu-item index="/short-numbers">
          <v-svg class="voxo-orange" sprite="list-numbers" />
          <span slot="title">Short Numbers</span>
        </el-menu-item>
        <el-menu-item index="/conference-bridges">
          <v-svg class="voxo-aqua" sprite="group-3" />
          <span slot="title">Conference Rooms</span>
        </el-menu-item>
        <el-menu-item index="/announcements">
          <v-svg class="voxo-red" sprite="megaphone" />
          <span slot="title">Announcements</span>
        </el-menu-item>
        <el-menu-item index="/musiconholds">
          <v-svg class="voxo-yellow" sprite="microphone" />
          <span slot="title">Music On Hold</span>
        </el-menu-item>
        <el-menu-item index="/media-files">
          <v-svg class="voxo-blue" sprite="microphone" />
          <span slot="title">Media Files</span>
        </el-menu-item>
        <el-menu-item index="/custom-destinations">
          <v-svg class="voxo-orange" sprite="list" />
          <span slot="title">Custom Destinations</span>
        </el-menu-item>
        <el-menu-item index="/button-layouts">
          <v-svg class="voxo-aqua" sprite="telephone-2" />
          <span slot="title">Button Layouts</span>
        </el-menu-item>
        <el-menu-item index="/phonebooks">
          <v-svg class="voxo-green" sprite="phone-number" />
          <span slot="title">Phone Books</span>
        </el-menu-item>
        <el-menu-item
          v-if="isSuper || isAccountAdmin || isPartner"
          index="/pharmacy-agents"
        >
          <v-svg class="voxo-orange" sprite="voicemail" />
          <span slot="title">Pharmacy Agents</span>
        </el-menu-item>
        <el-menu-item index="/parkinglots">
          <v-svg class="voxo-yellow" sprite="ambulance" />
          <span slot="title">Parking Lots</span>
        </el-menu-item>
      </el-submenu>

      <el-submenu index="Account" v-if="!reportingAdmin && !queueAdmin">
        <template slot="title">
          <v-svg class="voxo-purple" sprite="app" />
          <span>Account</span>
        </template>
        <el-menu-item index="/locations">
          <v-svg class="voxo-green" sprite="ambulance"></v-svg>
          <span slot="title">e911 Locations</span>
        </el-menu-item>
        <el-menu-item index="/number-porting">
          <v-svg class="voxo-aqua" sprite="call-forward"></v-svg>
          <span slot="title">Number Porting</span>
        </el-menu-item>
        <el-menu-item index="/users">
          <v-svg class="voxo-yellow" sprite="group-2" />
          <span slot="title">Users</span>
        </el-menu-item>
        <el-menu-item index="/branches">
          <v-svg class="voxo-blue" sprite="flow"></v-svg>
          <span slot="title">Branches</span>
        </el-menu-item>
        <el-menu-item @click="triggerRouteToAccounts" index="/settings">
          <v-svg class="voxo-red" sprite="gear"></v-svg>
          <span slot="title">Settings</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess10DLC" index="/10dlc-messaging">
          <v-svg class="white" sprite="message"></v-svg>
          <span slot="title">10DLC Messaging</span>
        </el-menu-item>
      </el-submenu>

      <el-submenu index="Billing" v-if="billingViewActive">
        <template slot="title">
          <v-svg class="voxo-orange" sprite="wallet" />
          <span>Billing</span>
        </template>
        <el-menu-item index="bill-redirect" v-if="redirectToBillerGenie">
          <v-svg class="voxo-blue" sprite="file-add" />
          <!--          <a
            @click.prevent="handleBillingRedirect"
            href="https://customer.billergenie.com:443/VOXO/Account/Login/11974"
            target="_blank"
            slot="title"
            style="text-decoration: none"
            >Billing History</a
          >-->
          <span slot="title">Billing Account</span>
        </el-menu-item>
        <el-menu-item v-else index="/bill-history">
          <v-svg class="voxo-blue" sprite="file-add" />
          <span slot="title">Billing History</span>
        </el-menu-item>
        <!--        <el-menu-item index="/payment-info">
          <v-svg class="voxo-green" sprite="credit-card"></v-svg>
          <span slot="title">Payment Info</span>
        </el-menu-item>-->
        <el-menu-item index="/extension-counts">
          <v-svg class="voxo-green" sprite="telephone-2"></v-svg>
          <span slot="title">Extension Count</span>
        </el-menu-item>
      </el-submenu>

      <el-submenu index="Reports" v-if="canAccessReporting">
        <template slot="title">
          <v-svg class="voxo-pink" sprite="report" />
          <span>Reports</span>
        </template>
        <el-menu-item
          index="/admin-audit-log"
          v-if="!reportingAdmin && !queueAdmin"
        >
          <v-svg class="voxo-orange" sprite="list" />
          <span slot="title">Admin Audit Log</span>
        </el-menu-item>
        <el-menu-item index="/call-recordings" v-if="canAccessCallRecordings">
          <v-svg class="voxo-purple" sprite="file-audio" />
          <span slot="title">Call Recordings</span>
        </el-menu-item>
        <el-menu-item index="/call-summary">
          <v-svg class="voxo-pink" sprite="bar-chart" />
          <span slot="title">Call Summary</span>
        </el-menu-item>
        <el-menu-item index="/call-stats" v-if="!queueAdmin || reportingAdmin">
          <v-svg class="voxo-purple" sprite="report"></v-svg>
          <span slot="title">Call Statistics</span>
        </el-menu-item>
        <el-menu-item index="/queue-reports">
          <v-svg class="voxo-red" sprite="queue"></v-svg>
          <span slot="title">Queues</span>
        </el-menu-item>
        <el-menu-item index="/ivr-reports" v-if="!queueAdmin || reportingAdmin">
          <v-svg class="voxo-purple" sprite="receptionist"></v-svg>
          <span slot="title">Virtual Receptionists</span>
        </el-menu-item>
        <el-menu-item
          index="/provision-reports"
          v-if="!queueAdmin && !reportingAdmin"
        >
          <v-svg class="voxo-yellow" sprite="profile"></v-svg>
          <span slot="title">Provisioning</span>
        </el-menu-item>
        <el-menu-item index="/sms-logs" v-if="!queueAdmin || reportingAdmin">
          <v-svg class="voxo-orange" sprite="message"></v-svg>
          <span slot="title">SMS Logs</span>
        </el-menu-item>
        <el-menu-item index="/user-logs" v-if="!queueAdmin || reportingAdmin">
          <v-svg class="voxo-aqua" sprite="profile"></v-svg>
          <span slot="title">User Logs</span>
        </el-menu-item>
        <el-menu-item index="/scheduled-reports" v-if="!queueAdmin">
          <v-svg class="voxo-red" sprite="clock"></v-svg>
          <span slot="title">Scheduled Reports</span>
        </el-menu-item>
      </el-submenu>

      <el-submenu index="SystemAdmin" v-if="!reportingAdmin && !queueAdmin">
        <template slot="title">
          <v-svg class="voxo-dark-red" sprite="home-user" />
          <span>System Admin</span>
        </template>
        <el-menu-item index="/accounts">
          <v-svg class="voxo-blue" sprite="lighthouse" />
          <span slot="title">Accounts</span>
        </el-menu-item>
        <el-menu-item index="/admin/phone-numbers">
          <v-svg class="voxo-aqua" sprite="phone-number" />
          <span slot="title">Phone Numbers</span>
        </el-menu-item>
        <el-menu-item index="/partners/porting">
          <v-svg class="voxo-aqua" sprite="call-forward"></v-svg>
          <span slot="title">Port Requests</span>
        </el-menu-item>
        <el-menu-item
          index="/port-out-requests"
          v-if="isPlatformOrPartnerAdmin"
        >
          <v-svg class="voxo-green" sprite="message"></v-svg
          ><span slot="title">Port Out Requests</span></el-menu-item
        >
        <el-menu-item index="/admin/users" v-show="isSuper">
          <v-svg class="voxo-yellow" sprite="group-2" />
          <span slot="title">Users</span>
        </el-menu-item>
        <el-menu-item index="/partners" v-show="isSuper">
          <v-svg class="voxo-aqua" sprite="world-hand" />
          <span slot="title">Partner Accounts</span>
        </el-menu-item>
        <el-menu-item index="/omnia-themes" v-show="isPlatformOrPartnerAdmin">
          <v-svg class="voxo-red" sprite="atoms" />
          <span slot="title">Omnia Themes</span>
        </el-menu-item>
        <el-menu-item index="/admin/feature-codes" v-show="isSuper">
          <v-svg class="voxo-blue" sprite="hash" />
          <span slot="title">Feature Codes</span>
        </el-menu-item>
        <el-menu-item index="/admin/time-of-days" v-show="isSuper">
          <v-svg class="voxo-green" sprite="clock" />
          <span slot="title">Time of Days</span>
        </el-menu-item>
        <el-menu-item index="/phone-models" v-show="isSuper">
          <v-svg class="voxo-orange" sprite="devices"></v-svg>
          <span slot="title">Phone Models</span>
        </el-menu-item>
        <el-menu-item index="/providers" v-show="isSuper">
          <v-svg class="voxo-purple" sprite="world-hand"></v-svg>
          <span slot="title">Providers</span>
        </el-menu-item>
        <el-menu-item index="/admin/musiconholds" v-show="isSuper">
          <v-svg class="voxo-yellow" sprite="microphone" />
          <span slot="title">Music On Hold</span>
        </el-menu-item>
        <el-menu-item index="/admin/mediafiles" v-show="isSuper">
          <v-svg class="voxo-blue" sprite="microphone" />
          <span slot="title">Media Files</span>
        </el-menu-item>
        <el-menu-item index="/admin/devices">
          <v-svg class="voxo-yellow" sprite="devices" />
          <span slot="title">Devices</span>
        </el-menu-item>
        <el-menu-item index="/routing-profiles" v-show="isSuper">
          <v-svg class="voxo-green" sprite="megaphone" />
          <span slot="title">Routing Profiles</span>
        </el-menu-item>
      </el-submenu>
    </el-menu>

    <el-menu
      ref="hudNav"
      v-if="hudMode"
      :default-active.sync="activeLink"
      :mode="mode"
      @select="goto"
      :collapse="isCollapse"
      :unique-opened="true"
      background-color="transparent"
      class="main-navigation-menu"
      :class="{ 'nav-collapsed': isCollapse }"
    >
      <el-menu-item index="/omnia/contacts">
        <v-svg class="voxo-blue" sprite="user" />
        <span slot="title">Contacts</span>
      </el-menu-item>

      <el-menu-item index="/omnia/activity">
        <v-svg class="voxo-orange" sprite="bar-chart" />
        <span slot="title">My Activity</span>
      </el-menu-item>

      <el-menu-item index="/omnia/call-summary">
        <v-svg class="voxo-pink" sprite="books" />
        <span slot="title">Call Summary</span>
      </el-menu-item>

      <el-menu-item index="/omnia/call-recordings">
        <v-svg class="voxo-blue" sprite="file-audio" />
        <span slot="title">Call Recordings</span>
      </el-menu-item>

      <el-submenu index="UserPanelCallQueues">
        <template slot="title">
          <v-svg class="voxo-dark-red" sprite="queue" />
          <span>Call Queues</span>
        </template>
        <el-menu-item index="/omnia/queues" v-if="allowQueues">
          <v-svg class="voxo-purple" sprite="group-4" />
          <span slot="title">Agent Dashboard</span>
        </el-menu-item>

        <el-menu-item
          index="/omnia/queue-dashboard"
          v-if="queueDashboardActive"
        >
          <v-svg class="voxo-red" sprite="report" />
          <div class="flex align-center">
            <span slot="title" class="mr-10"> Live Stats </span>
            <!-- <div>
              <el-tag type="success" rounded style="padding: 3px; height: 20px; line-height: 12px"> Beta </el-tag>
            </div> -->
          </div>
        </el-menu-item>
      </el-submenu>

      <el-menu-item index="/omnia/operator" v-if="allowOperator">
        <v-svg class="voxo-green" sprite="receptionist" />
        <span slot="title">Operator Panel</span>
      </el-menu-item>
    </el-menu>

    <!--    Meet modal dialogue-->
    <el-dialog
      :visible.sync="meetModalVisible"
      width="425px"
      :before-close="resetScheduleFields"
      :close-on-click-modal="false"
      :modal="false"
    >
      <div v-loading="meetInfoLoading">
        <div v-if="meetURL">
          <h2 class="form-section-header black-text">Meeting ready!</h2>
          <div class="card-base card-shadow--medium black-text ph-10">
            <el-row>
              <el-col :span="18">
                <el-row class="flex align-center mt-5">
                  <h4 class="mb-0 mt-0">Meeting id:</h4>
                  <span class="black-text ml-5"> {{ roomId }}</span>
                </el-row>
                <el-row class="flex align-center mt-5">
                  <h4 class="mb-0 mt-0">Dial In Number:</h4>
                  <span class="black-text ml-5"> {{ dialInNum }}</span>
                </el-row>
                <el-row class="mb-0 mt-5 flex align-center">
                  <h4 class="mb-0 mt-0">PIN:</h4>
                  <span class="ml-5 black-text"> {{ pin }}</span>
                </el-row>
              </el-col>
              <el-col :span="1" />
              <el-col :span="6" class="text-right">
                <el-tooltip placement="top" content="Copy meeting info">
                  <el-button
                    @click="copyMeetInfo"
                    class="table-action-button mt-5"
                  >
                    <i class="mdi mdi-content-copy" />
                  </el-button>
                </el-tooltip>
              </el-col>
            </el-row>
          </div>
          <!--          <el-tag class="mb-10 mt-10" type="warning">
            <i class="el-icon-warning" style="margin-right: 4px"></i>
            Meeting room expires in 2 days
          </el-tag>-->
        </div>
        <div v-else>
          <h2 class="form-section-header black-text">
            Video meetings not enabled
          </h2>
          <p class="black-text">
            Video calls are not enabled for your extension. Contact an admin for
            help.
          </p>
        </div>

        <div class="flex mt-10 justify-flex-end" v-if="meetURL">
          <el-button @click="joinMeeting">Join Meeting</el-button>
        </div>
      </div>
    </el-dialog>

    <!--    SCHEDULE MEET DIALOG-->
    <el-dialog
      :visible.sync="scheduleMeetModalVisible"
      width="500px"
      :close-on-click-modal="false"
      :before-close="resetScheduleFields"
      :modal="false"
    >
      <el-form class="form-modal" v-loading="meetInfoLoading">
        <h2 class="form-section-header black-text">Meeting details</h2>

        <el-input v-model="scheduleForm.meetingTitle" placeholder="Enter title">
          <template slot="prefix"> Title </template>
        </el-input>

        <el-select
          v-model="scheduleForm.calendarType"
          placeholder="Select calendar"
        >
          <template slot="prefix"> Calendar </template>
          <el-option value="google" label="Google">
            <div class="flex align-center">
              <span class="calendar-icon"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 122.88 122.88"
                >
                  <path d="M93.78 29.1H29.1v64.68h64.68V29.1z" fill="#fff" />
                  <path
                    d="M93.78 122.88l29.1-29.1h-29.1v29.1z"
                    fill="#f72a25"
                  />
                  <path
                    d="M122.88 29.1h-29.1v64.68h29.1V29.1z"
                    fill="#fbbc04"
                  />
                  <path
                    d="M93.78 93.78H29.1v29.1h64.68v-29.1z"
                    fill="#34a853"
                  />
                  <path
                    d="M0 93.78v19.4c0 5.36 4.34 9.7 9.7 9.7h19.4v-29.1H0h0z"
                    fill="#188038"
                  />
                  <path
                    d="M122.88 29.1V9.7c0-5.36-4.34-9.7-9.7-9.7h-19.4v29.1h29.1 0z"
                    fill="#1967d2"
                  />
                  <path
                    d="M93.78 0H9.7C4.34 0 0 4.34 0 9.7v84.08h29.1V29.1h64.67V0h.01z"
                    fill="#4285f4"
                  />
                  <path
                    d="M42.37 79.27c-2.42-1.63-4.09-4.02-5-7.17l5.61-2.31c.51 1.94 1.4 3.44 2.67 4.51 1.26 1.07 2.8 1.59 4.59 1.59 1.84 0 3.41-.56 4.73-1.67 1.32-1.12 1.98-2.54 1.98-4.26 0-1.76-.7-3.2-2.09-4.32s-3.14-1.67-5.22-1.67H46.4v-5.55h2.91c1.79 0 3.31-.48 4.54-1.46 1.23-.97 1.84-2.3 1.84-3.99 0-1.5-.55-2.7-1.65-3.6s-2.49-1.35-4.18-1.35c-1.65 0-2.96.44-3.93 1.32s-1.7 2-2.12 3.24l-5.55-2.31c.74-2.09 2.09-3.93 4.07-5.52s4.51-2.39 7.58-2.39c2.27 0 4.32.44 6.13 1.32s3.23 2.1 4.26 3.65c1.03 1.56 1.54 3.31 1.54 5.25 0 1.98-.48 3.65-1.43 5.03-.95 1.37-2.13 2.43-3.52 3.16v.33c1.79.74 3.36 1.96 4.51 3.52 1.17 1.58 1.76 3.46 1.76 5.66s-.56 4.16-1.67 5.88c-1.12 1.72-2.66 3.08-4.62 4.07s-4.17 1.49-6.62 1.49c-2.84 0-5.46-.81-7.88-2.45h0 0zm34.46-27.84l-6.16 4.45-3.08-4.67 11.05-7.97h4.24v37.6h-6.05V51.43h0z"
                    fill="#1a73e8"
                  /></svg
              ></span>
              <span class="ml-10">Google</span>
            </div>
          </el-option>
          <el-option value="outlook" label="Outlook.com">
            <div class="flex align-center">
              <span class="calendar-icon"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="-0.129793726981 0 33.251996719421 32"
                  width="25"
                  height="25"
                >
                  <path
                    d="M28.596 2H11.404A1.404 1.404 0 0 0 10 3.404V5l9.69 3L30 5V3.404A1.404 1.404 0 0 0 28.596 2z"
                    fill="#0364b8"
                  />
                  <path
                    d="M31.65 17.405A11.341 11.341 0 0 0 32 16a.666.666 0 0 0-.333-.576l-.013-.008-.004-.002L20.812 9.24a1.499 1.499 0 0 0-1.479-.083 1.49 1.49 0 0 0-.145.082L8.35 15.415l-.004.002-.012.007A.666.666 0 0 0 8 16a11.344 11.344 0 0 0 .35 1.405l11.492 8.405z"
                    fill="#0a2767"
                  />
                  <path d="M24 5h-7l-2.021 3L17 11l7 6h6v-6z" fill="#28a8ea" />
                  <path d="M10 5h7v6h-7z" fill="#0078d4" />
                  <path d="M24 5h6v6h-6z" fill="#50d9ff" />
                  <path d="M24 17l-7-6h-7v6l7 6 10.832 1.768z" fill="#0364b8" />
                  <path d="M17 11h7v6h-7z" fill="#0078d4" />
                  <path d="M10 17h7v6h-7z" fill="#064a8c" />
                  <path d="M24 17h6v6h-6z" fill="#0078d4" />
                  <path
                    d="M20.19 25.218l-11.793-8.6.495-.87 10.909 6.212a.528.528 0 0 0 .42-.012l10.933-6.23.496.869z"
                    fill="#0a2767"
                    opacity=".5"
                  />
                  <path
                    d="M31.667 16.577l-.014.008-.003.002-10.838 6.174a1.497 1.497 0 0 1-1.46.091l3.774 5.061 8.254 1.797v.004A1.498 1.498 0 0 0 32 28.5V16a.666.666 0 0 1-.333.577z"
                    fill="#1490df"
                  />
                  <path
                    d="M32 28.5v-.738l-9.983-5.688-1.205.687a1.497 1.497 0 0 1-1.46.091l3.774 5.061 8.254 1.797v.004A1.498 1.498 0 0 0 32 28.5z"
                    opacity=".05"
                  />
                  <path
                    d="M31.95 28.883L21.007 22.65l-.195.11a1.497 1.497 0 0 1-1.46.092l3.774 5.061 8.254 1.797v.004a1.501 1.501 0 0 0 .57-.83z"
                    opacity=".1"
                  />
                  <path
                    d="M8.35 16.59v-.01h-.01l-.03-.02A.65.65 0 0 1 8 16v12.5A1.498 1.498 0 0 0 9.5 30h21a1.503 1.503 0 0 0 .37-.05.637.637 0 0 0 .18-.06.142.142 0 0 0 .06-.02 1.048 1.048 0 0 0 .23-.13c.02-.01.03-.01.04-.03z"
                    fill="#28a8ea"
                  />
                  <path
                    d="M18 24.667V8.333A1.337 1.337 0 0 0 16.667 7H10.03v7.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16v10h8.667A1.337 1.337 0 0 0 18 24.667z"
                    opacity=".1"
                  />
                  <path
                    d="M17 25.667V9.333A1.337 1.337 0 0 0 15.667 8H10.03v6.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16v11h7.667A1.337 1.337 0 0 0 17 25.667z"
                    opacity=".2"
                  />
                  <path
                    d="M17 23.667V9.333A1.337 1.337 0 0 0 15.667 8H10.03v6.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16v9h7.667A1.337 1.337 0 0 0 17 23.667z"
                    opacity=".2"
                  />
                  <path
                    d="M16 23.667V9.333A1.337 1.337 0 0 0 14.667 8H10.03v6.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16v9h6.667A1.337 1.337 0 0 0 16 23.667z"
                    opacity=".2"
                  />
                  <path
                    d="M1.333 8h13.334A1.333 1.333 0 0 1 16 9.333v13.334A1.333 1.333 0 0 1 14.667 24H1.333A1.333 1.333 0 0 1 0 22.667V9.333A1.333 1.333 0 0 1 1.333 8z"
                    fill="#0078d4"
                  />
                  <path
                    d="M3.867 13.468a4.181 4.181 0 0 1 1.642-1.814A4.965 4.965 0 0 1 8.119 11a4.617 4.617 0 0 1 2.413.62 4.14 4.14 0 0 1 1.598 1.733 5.597 5.597 0 0 1 .56 2.55 5.901 5.901 0 0 1-.577 2.666 4.239 4.239 0 0 1-1.645 1.794A4.8 4.8 0 0 1 7.963 21a4.729 4.729 0 0 1-2.468-.627 4.204 4.204 0 0 1-1.618-1.736 5.459 5.459 0 0 1-.567-2.519 6.055 6.055 0 0 1 .557-2.65zm1.75 4.258a2.716 2.716 0 0 0 .923 1.194 2.411 2.411 0 0 0 1.443.435 2.533 2.533 0 0 0 1.541-.449 2.603 2.603 0 0 0 .897-1.197 4.626 4.626 0 0 0 .286-1.665 5.063 5.063 0 0 0-.27-1.686 2.669 2.669 0 0 0-.866-1.24 2.387 2.387 0 0 0-1.527-.473 2.493 2.493 0 0 0-1.477.439 2.741 2.741 0 0 0-.944 1.203 4.776 4.776 0 0 0-.007 3.44z"
                    fill="#fff"
                  /></svg
              ></span>
              <span class="ml-10">Outlook.com</span>
            </div>
          </el-option>
          <el-option value="office" label="Office 365">
            <div class="flex align-center">
              <span class="calendar-icon"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 278050 333334"
                  shape-rendering="geometricPrecision"
                  image-rendering="optimizeQuality"
                  fill-rule="evenodd"
                >
                  <path
                    fill="#ea3e23"
                    d="M278050 305556l-29-16V28627L178807 0 448 66971l-448 87 22 200227 60865-23821V80555l117920-28193-17 239519L122 267285l178668 65976v73l99231-27462v-316z"
                  /></svg
              ></span>
              <span class="ml-10">Microsoft 365</span>
            </div>
          </el-option>
        </el-select>

        <el-checkbox
          v-model="scheduleForm.isRecurringEvent"
          style="margin-left: 0; display: inline-block"
        >
          <span class="mr-5">Recurring event</span>
        </el-checkbox>
        <el-popover
          trigger="hover"
          placement="bottom"
          v-if="!scheduleForm.isRecurringEvent"
        >
          <i
            class="more-info-icon el-icon-warning voxo-orange"
            slot="reference"
          />
          <p class="black-text pt-0 pb-0" style="max-width: 275px">
            Non-recurring event rooms expire 2 weeks after the selected end
            date.
          </p>
        </el-popover>

        <h3 class="black-text mb-0">Select time</h3>
        <div class="inline-form-group">
          <el-col :span="10">
            <el-date-picker
              class="mb-10"
              style="margin-left: auto; max-width: 190px"
              v-model="scheduleForm.meetingDate"
              placeholder="Date"
              :clearable="false"
              format="ddd, MMM d, yyyy"
            />
          </el-col>
          <el-col :span="1" />
          <el-col :span="6">
            <omnia-time-select
              @onTimeSelected="setStartTime"
              v-model="scheduleForm.meetingStartTime"
              start="00:00"
              end="23:59"
              step="00:15"
              title="Start"
            />
          </el-col>
          <el-col :span="1" class="text-center" />
          <el-col :span="6">
            <omnia-time-select
              @onTimeSelected="setEndTime"
              v-model="scheduleForm.meetingEndTime"
              :start="scheduleForm.meetingStartTime"
              end="23:59"
              step="00:15"
              title="End"
            />
          </el-col>
        </div>

        <div>
          <div v-if="meetURL">
            <h2 class="form-section-header black-text">Meeting scheduled!</h2>
            <div class="card-base card-shadow--medium black-text ph-10">
              <el-row>
                <el-col :span="18">
                  <el-row class="flex align-center mt-5">
                    <h4 class="mb-0 mt-0">Meeting id:</h4>
                    <span class="black-text ml-5"> {{ roomId }}</span>
                  </el-row>
                  <el-row class="flex align-center mt-5">
                    <h4 class="mb-0 mt-0">Dial In Number:</h4>
                    <span class="black-text ml-5"> {{ dialInNum }}</span>
                  </el-row>
                  <el-row class="mb-0 mt-5 flex align-center">
                    <h4 class="mb-0 mt-0">PIN:</h4>
                    <span class="ml-5 black-text"> {{ pin }}</span>
                  </el-row>
                </el-col>
                <el-col :span="1" />
                <el-col :span="6" class="text-right">
                  <el-tooltip placement="top" content="Copy meeting info">
                    <el-button
                      @click="copyMeetInfo"
                      class="table-action-button mt-5"
                    >
                      <i class="mdi mdi-content-copy" />
                    </el-button>
                  </el-tooltip>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>

        <div>
          <el-button
            v-if="scheduledMeetingData"
            class="mt-20"
            @click="addToCalendar"
          >
            Add to Calendar
          </el-button>
          <el-button v-else class="mt-20" @click="generateScheduledMeeting">
            Schedule Meeting
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { detect } from "detect-browser";
import { mapGetters } from "vuex";
import { isMobileDevice } from "@/globals/globals";
import MiniKeypad from "../views/hudportal/softphone/components/mini-keypad";
import ConnectedCall from "../views/hudportal/softphone/components/connected-call";
import ParkedCall from "../views/hudportal/softphone/components/parked-call";
import feathersClient, { apiV2Host } from "@/feathers/feathers-client";
import OmniaTimeSelect from "../components/OmniaTimeSelect";
import moment from "moment-timezone";
import axios from "axios";

const browser = detect();

export default {
  name: "Nav",
  props: ["mode", "isCollapse"],
  components: { ConnectedCall, MiniKeypad, ParkedCall, OmniaTimeSelect },
  data() {
    return {
      isIe: true,
      isEdge: true,
      activeLink: null,
      meetURL: null,
      meetDial: null,
      meetModalVisible: false,
      meetInfoLoading: false,
      dialInNum: "",
      pin: "",
      roomId: "",
      joinURL: "",
      scheduleMeetModalVisible: false,
      scheduledMeetingData: null,
      scheduleForm: {
        calendarType: "",
        isRecurringEvent: false,
        meetingTitle: "",
        meetingDate: moment(),
        meetingStartTime: moment()
          .startOf("hour")
          .add(1, "hour")
          .format("HH:mm"),
        meetingEndTime: moment().startOf("hour").add(2, "hour").format("HH:mm"),
        meetingInfo: ""
      }
    };
  },
  methods: {
    async goto(index, indexPath) {
      if (index === "bill-redirect") {
        const redirect = this.isPharmacyBillingV2
          ? "https://pharmacy.voxo.co/settings"
          : "https://customer.billergenie.com:443/VOXO/Account/Login/11974";

        return window.open(redirect, "_blank", "noopener");
      }

      if (index.charAt(0) === "/") {
        this.$router.push(index);
        this.$emit("push-page", { page: index });
      }
    },

    setLink(path) {
      this.activeLink = path;
    },

    toggleSoftphone(val) {
      this.$store.commit("setSoftphoneVisibility", val);
    },

    triggerRouteToAccounts() {
      this.$router.push({
        name: "accounts",
        params: { tenantId: this.selectedTenant.id }
      });
    },

    onCommand(cmd) {
      switch (cmd) {
        case "startVideoCall":
          this.startVideoCall();
          break;
        case "scheduleVideoCall":
          this.scheduleMeetModalVisible = true;
          break;
        default:
          break;
      }
    },

    joinMeeting() {
      window.open(this.joinURL, "_blank", "noopener");
      this.meetModalVisible = false;
    },

    copyMeetInfo() {
      const text = `To join the video meeting, click this link: ${this.meetURL}\nOtherwise, to join by phone, dial ${this.meetDial}\n`;
      navigator.clipboard.writeText(text);
      this.$message({
        message: "Copied meeting info!",
        type: "success",
        duration: 1500
      });
    },

    //create the meeting room and redirect
    async startVideoCall() {
      const { myExtension } = this.user;

      if (!myExtension) {
        this.meetInfoLoading = false;
        return;
      }

      this.meetInfoLoading = true;
      this.meetModalVisible = true;

      const res = await this.createMeeting();

      if (!res) {
        this.$notify({
          type: "error",
          title: "Meeting Creation Failed",
          message: "Your meeting could not be created"
        });
        this.meetInfoLoading = false;
        return;
      }

      const { meetURL, dialIn, dialInNum, pin, roomId } = res;

      this.meetURL = meetURL;
      this.meetDial = dialIn;
      this.dialInNum = dialInNum;
      this.pin = pin;
      this.roomId = roomId;
      this.joinURL = meetURL;

      this.meetInfoLoading = false;
    },

    async createMeeting() {
      const url = `${apiV2Host}/meet/create`;
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + this.$store.state.auth.accessToken
          }
        });

        if (!response.ok) return;

        return await response.json();
      } catch (e) {
        console.log(e);
      }
    },

    //redirects user to their calendar
    async generateScheduledMeeting() {
      this.meetInfoLoading = true;

      //send request to generate the room
      const meetingData = await this.createMeeting();

      console.log("hello there");

      if (!meetingData) {
        this.$notify({
          type: "error",
          title: "Scheduling Failed",
          message: "Your meeting could not be scheduled"
        });
        this.meetInfoLoading = false;
        return;
      }

      this.scheduledMeetingData = meetingData;

      const { meetURL, dialIn, dialInNum, pin, roomId } = meetingData;
      this.meetURL = meetURL;
      this.meetDial = dialIn;
      this.dialInNum = dialInNum;
      this.pin = pin;
      this.roomId = roomId;
      this.joinURL = meetURL;

      this.meetInfoLoading = false;
    },

    addToCalendar() {
      //make sure a calendar type was selected
      if (!this.scheduleForm.calendarType) {
        this.$notify({
          type: "error",
          title: "Invalid Data",
          message: "You must select a calendar type."
        });
        this.meetInfoLoading = false;
        return;
      }

      //use payload to populate event description data
      const { meetURL, dialIn } = this.scheduledMeetingData;
      this.scheduleForm.meetingInfo = `To join the video meeting, click this link: ${meetURL}\nOtherwise, to join by phone, dial ${dialIn}\n`;

      //open the new tab with the completed calendar URL.
      const calendarURL = this.buildCalendarURL();
      if (calendarURL) {
        window.open(calendarURL, "_blank").focus();
      }

      this.resetScheduleFields();
    },

    //build the calendar URL
    buildCalendarURL() {
      const {
        calendarType,
        meetingTitle,
        meetingDate,
        meetingInfo,
        meetingStartTime,
        meetingEndTime
      } = this.scheduleForm;

      const startTimeFormatted = `${moment(meetingDate).format(
        "YYYY-MM-DD"
      )} ${meetingStartTime}`;
      const startDateGoogle =
        moment(startTimeFormatted).format("YYYYMMDDTHHmmss");
      const startDateMicrosoft = moment(startTimeFormatted).format(
        "YYYY-MM-DDTHH:mm:ss"
      );

      const endTimeFormatted = `${moment(meetingDate).format(
        "YYYY-MM-DD"
      )} ${meetingEndTime}`;
      const endDateGoogle = moment(endTimeFormatted).format("YYYYMMDDTHHmmss");
      const endDateMicrosoft = moment(endTimeFormatted).format(
        "YYYY-MM-DDTHH:mm:ss"
      );

      if (calendarType === "google") {
        return `https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${startDateGoogle}%2F${endDateGoogle}&details=${encodeURIComponent(
          meetingInfo
        )}&text=${encodeURIComponent(meetingTitle)}`;
      }

      if (calendarType === "outlook") {
        return `https://outlook.live.com/calendar/0/deeplink/compose?path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=${startDateMicrosoft}&enddt=${endDateMicrosoft}&body=${encodeURIComponent(
          meetingInfo
        )}&subject=${encodeURIComponent(meetingTitle)}`;
      }

      if (calendarType === "office") {
        return `https://outlook.office.com/calendar/0/deeplink/compose?path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=${startDateMicrosoft}&enddt=${endDateMicrosoft}&body=${encodeURIComponent(
          meetingInfo
        )}&subject=${encodeURIComponent(meetingTitle)}`;
      }

      return null;
    },

    //reset the scheduler fields
    resetScheduleFields() {
      this.meetModalVisible = false;
      this.scheduleMeetModalVisible = false;
      this.meetInfoLoading = false;
      this.scheduledMeetingData = null;
      this.scheduleForm = {
        calendarType: "",
        isRecurringEvent: false,
        meetingTitle: "",
        meetingDate: moment(),
        meetingStartTime: moment()
          .startOf("hour")
          .add(1, "hour")
          .format("HH:mm"),
        meetingEndTime: moment().startOf("hour").add(2, "hour").format("HH:mm"),
        meetingInfo: ""
      };
      this.meetURL = "";
      this.meetDial = "";
      this.dialInNum = "";
      this.pin = "";
      this.roomId = "";
      this.joinURL = "";
    },

    setStartTime(val) {
      this.scheduleForm.meetingStartTime = val;

      if (val > this.scheduleForm.meetingEndTime) {
        if (val >= "23:00") {
          this.scheduleForm.meetingEndTime = "23:45";
        } else {
          const startTimeFormatted = `${moment(
            this.scheduleForm.meetingDate
          ).format("YYYY-MM-DD")} ${this.scheduleForm.meetingStartTime}`;
          this.scheduleForm.meetingEndTime = moment(startTimeFormatted)
            .add(1, "hour")
            .format("HH:mm");
        }
      }
    },

    setEndTime(val) {
      this.scheduleForm.meetingEndTime = val;
    }
  },
  computed: {
    ...mapGetters("mycurrentcalls", { myCallsList: "find" }),
    ...mapGetters("myparkedcalls", { parkedCallsList: "find" }),

    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    hudMode() {
      return this.$store.state.hudMode;
    },

    queueMode() {
      return this.$store.state.queueMode;
    },

    user() {
      return this.$store.state.auth.user;
    },
    isSuper() {
      if (this.user) {
        return +this.user.userRole === 1;
      }
    },
    isAccountAdmin() {
      if (this.user) {
        return +this.user.userRole === 3 || +this.user.userRole === 12;
      }
    },
    isPlatformOrPartnerAdmin() {
      if (this.user) {
        return +this.user.userRole === 1 || +this.user.userRole === 11;
      }
    },
    isPartner() {
      if (this.user) {
        return +this.user.userRole === 11;
      }
    },
    adminRoute() {
      if (this.user) {
        if (
          +this.user.userRole === 5 ||
          +this.user.userRole === 13 ||
          +this.user.userRole === 14
        ) {
          return false;
        }
      }
      return true;
    },
    allowQueues() {
      if (this.user) {
        const { isResidential, queueIds } = this.user.myExtension;
        if (isResidential) {
          return false;
        }

        const baseRoles = [5, 9, 13, 14];
        if (!baseRoles.includes(+this.user.userRole)) {
          return true;
        }
        if (+this.user.userRole === 7) {
          const { adminQueues } = this.user;
          if (adminQueues.length) {
            return true;
          }
        }
        if (this.user.hasOwnProperty("myExtension")) {
          if (queueIds.length) {
            return true;
          }
        }
      }
      return false;
    },
    allowOperator() {
      if (this.user) {
        const { enableOperatorPanel } = this.user;
        const { isResidential } = this.user.myExtension;
        return enableOperatorPanel && !isResidential;
      }
      return false;
    },
    myCurrentCalls() {
      return this.myCallsList().data;
    },
    myParkedCalls() {
      return this.parkedCallsList().data;
    },
    userHasExtension() {
      if (this.user) {
        return this.user.hasOwnProperty("myExtension");
      }
      return false;
    },
    navCollapsed() {
      return this.$store.state.collapseNav;
    },
    softphoneEnabled() {
      return this.$store.state.softphoneEnabled;
    },
    reportingAdmin() {
      if (this.user) {
        const { userRole, enableReporting } = this.user;
        return +userRole === 9 || (+userRole === 7 && enableReporting);
      }
      return false;
    },
    canAccessReporting() {
      if (this.user) {
        const { userRole, enableReporting } = this.user;
        if (+userRole !== 3 && +userRole !== 12) return true;
        return (+userRole === 3 || +userRole === 12) && enableReporting;
      }
      return false;
    },
    canAccess10DLC() {
      if (this.user) {
        const { userRole } = this.user;
        return [1, 3, 11, 12].includes(+userRole);
      }
    },
    canAccessCallRecordings() {
      if (this.user) {
        const { userRole, enableReporting, accessCallRecordings } = this.user;

        if (+userRole === 1 || +userRole === 11) return true;

        if ((+userRole === 3 || +userRole === 12) && enableReporting)
          return true;

        return +userRole === 9 || (+userRole === 7 && accessCallRecordings);
      }
      return false;
    },
    queueAdmin() {
      if (this.user) {
        return +this.user.userRole === 7;
      }
      return false;
    },
    mobileDevice() {
      return isMobileDevice();
    },
    billingViewActive() {
      if (this.isSuper) {
        return true;
      }

      if (this.isPartner) {
        return true;
      }

      if (this.queueAdmin || this.reportingAdmin) {
        return false;
      }

      //must be account admin
      return true;
    },
    redirectToBillerGenie() {
      return (
        !this.selectedTenant.isResellerAccount &&
        this.selectedTenant.resellerType !== "WHITELABEL"
      );
    },
    isPharmacyBillingV2() {
      return (
        this.selectedTenant.billingV2 === 1 &&
        this.selectedTenant.healthcareVertical === "pharmacy"
      );
    },
    queueDashboardActive() {
      const roles = [1, 3, 7, 11, 12];
      return this.user ? roles.includes(+this.user.userRole) : false;
    }
  },

  created() {
    if (browser.name !== "ie") this.isIe = false;
    if (browser.name !== "edge") this.isEdge = false;

    this.setLink(this.$router.currentRoute.path);
    this.$router.afterEach((to, from) => {
      this.setLink(this.$router.currentRoute.path);
    });
  }
};
</script>
<!-- Scoped css needed here for side nav -->
<style lang="scss" scoped>
@import "../assets/scss/_variables";

.el-menu {
  padding-top: 5px;
  border: none;
  padding-left: 10px;
  background-color: transparent !important;
}

.el-menu::before,
.el-menu::after {
  display: none;
}

.el-submenu,
.el-menu-item {
  .mdi,
  svg {
    vertical-align: middle;
    margin-right: 5px;
    display: inline-block;
    min-width: 24px;
    text-align: center;
    font-size: 24px;
  }
}
</style>

<style lang="scss">
@import "../assets/scss/variables";

.main-navigation-menu {
  transition: width 0.1s;
  padding-bottom: 50px; /* Added padding to prevent routes from being hidden behind sticky bottom elements */

  // Just delete the same stuff here as above

  &:not(.el-menu--collapse) {
    .el-submenu__title,
    .el-menu-item {
      padding-left: 10px !important;
      font-size: 15px;
      height: 38px;
      line-height: 30px;
      margin: 0;
      background-color: transparent !important;
    }

    &:not(.el-menu--horizontal) {
      .el-menu-item,
      .el-submenu:not(.is-opened) {
        position: relative;
        border-radius: 4px;

        &:hover {
          background-color: $background-color-accent !important;
        }

        &.is-active {
          color: #fff;
          background-color: $background-color-accent !important;

          &::before {
            background: $text-color-accent;
          }
        }
      }
    }

    .el-submenu.is-opened {
      background-color: transparent !important;
      position: relative;

      li {
        padding-left: 12px !important;
        line-height: 33px;
        margin: 0 5px 0 25px;
      }

      &::before {
        display: none;
      }

      .el-menu-item,
      .el-submenu {
        &::before,
        &::after {
          display: none;
        }
      }
    }

    .el-menu-item-group__title {
      padding: 15px 0 0px 20px;
      color: transparentize($text-color, 0.65);
    }
  }

  .el-submenu__title,
  .el-menu-item:not(.is-active) {
    color: $text-color;
    i {
      color: #a3adb8;
    }
  }

  &.el-menu--collapse {
    .el-menu-item-group__title {
      padding: 15px 0 0px 0px;
      width: 100%;
      text-align: center;
    }
  }

  &.el-menu--horizontal {
    white-space: nowrap;
    overflow: hidden;
    display: table;

    & > * {
      display: inline-block;
    }
  }

  &.nav-collapsed {
    .el-menu-item,
    .el-submenu__title {
      & > span {
        display: none;
      }
    }
  }
}

.main-navigation-submenu {
  .el-menu {
    background: #fff !important;

    .el-menu-item:not(.is-active) {
      color: $text-color;
    }

    .el-menu-item:hover {
      background-color: transparentize($background-color, 0.3) !important;
    }
  }
}

.el-submenu__icon-arrow {
  font-size: 15px;
  right: 10px;
}

.el-checkbox {
  display: block;
  margin-left: 15px;
}

.el-checkbox + .el-checkbox {
  margin-left: 15px;
}

.hud-subheader {
  margin: 0 10px 5px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.filter-group {
  margin-bottom: 5px;
}

.el-switch {
  padding-left: 12px;
}

.omnia-name {
  letter-spacing: 2px;
}

.current-call-item {
  padding: 3px;
  margin: 8px 0 8px 10px;
  position: relative;
}

.el-card {
  font-size: 13px;
  border: none;
  border-radius: 6px;

  .el-card__header {
    padding: 6px;

    .avatar-group {
      align-items: center;
      justify-content: center;

      .contact-avatar {
        background-color: $background-color;
        box-shadow: inset 0 0 0 1px #c4cdd5, 0 1px 0 rgba(44, 45, 48, 0.15);
        color: #606266;
        border-radius: 6px;

        svg {
          width: 16px;
        }
      }
    }
  }

  .el-card__body {
    padding: 6px;
  }
}

.call-connection-info {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  div {
    display: flex;
  }

  .el-button {
    padding: 12px 14px;
  }

  .el-button--info {
    border-color: transparent;
  }

  .keypad-btn {
    margin-left: auto;
    background-color: $voxo-purple;
  }

  .el-button--mini {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 17px;
      padding-top: 3px;
    }
  }
}

.atxfer-popover {
  min-width: 70px;
  margin-left: 10px;
  padding: 8px 2px;
  .popper__arrow {
    left: 16px !important;
  }
  .el-button {
    width: 31px;
    height: 31px;

    svg {
      width: 17px;
      margin-top: -3px;
    }
  }
}

.call-actions {
  display: flex;
}

.caller-id {
  padding-left: 8px;
  line-height: 13px;
}

.caller-id-number {
  font-size: 11px;
}

.call-badge {
  float: right;
  border-radius: 6px;
  margin-left: auto;
  line-height: 10px;

  .el-badge__content {
    font-weight: 600;
    border-radius: 6px;
  }
}

.connected-call-pop {
  border: none;
  padding: 8px;
  background: transparent !important;
  box-shadow: none;
}

.section-link {
  display: flex;
  align-items: center;
  padding-left: 11px !important;
  font-size: 16px;
  height: 38px;
  line-height: 30px;
  margin: 5px 0;
  background-color: transparent !important;
  color: inherit;
  text-decoration: none;
  svg {
    margin-right: 10px;
  }
}

.content-center {
  justify-content: center;
}

.make-call-button {
  padding: 0 10px 10px 10px;
  width: 200px;
  top: 0;
  z-index: 100;
  background-color: inherit;
  position: sticky;

  span {
    display: flex;
    justify-content: center;
    align-content: center;
  }

  .make-call-text {
    margin-top: 2px;
    font-size: 15px;
  }
}

.make-call-dropdown {
  margin-left: 0 !important;
  .el-icon--right {
    margin-left: 0;
  }
  .el-button {
    height: 44px;
    width: 35px;
    padding: 11px 10px;
  }
}

.calendar-icon {
  width: 25px;
  height: 25px;
  text-align: right;
  svg {
    height: 100%;
    color: #333;
    width: auto;
  }
}
</style>
